export const moduleTypes = [
    "SCHEME",
    "JOB",
    "SURVEY",
    "HOSPITAL",
    "SERVICES",
    "NEEDS",
    "EXTERNAL",
    "CMS",
    "PROFILE",
    "HOMEPAGE",
    "REFERRAL",
];

export const labels = [
    { label: "Content ID" },
    { label: "Content Name" },
    { label: "Title" },
    { label: "Description" },
    { label: "Module" },
    { label: "Created At" },
    { label: "Actions" },
];
